import { motion } from 'framer-motion';
import useText from '@/hooks/useText';
import { FeatureCard } from './FeatureCard';
import { TrophyIcon } from '@heroicons/react/24/outline';
import { useFoundationCards } from './helpers';

export function FoundationsSection() {
  const sectionTitle = useText('about_disgenet.foundation.title');
  const achievementTitle = useText('about_disgenet.foundation.achievement_title');
  const achievement1 = useText('about_disgenet.foundation.achievement_1');
  const achievement2 = useText('about_disgenet.foundation.achievement_2');
  const achievement3 = useText('about_disgenet.foundation.achievement_3');
  const achievement4 = useText('about_disgenet.foundation.achievement_4');
  const footer = useText('about_disgenet.foundation.footer');
  const socialProof = useText('about_disgenet.foundation.social_proof');
  const cards = useFoundationCards();

  return (
    <section className="about-foundations mt-8">
      <div className="about-foundations__inner">
        <motion.h2
          className="about-foundations__title"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          {sectionTitle}
        </motion.h2>

        <div className="about-foundations__grid">
          {cards.map((card, i) => (
            <FeatureCard
              key={card.title}
              title={card.title}
              points={card.points}
              badgeText={card.badgeText}
              icon={card.icon}
              index={i}
            />
          ))}
        </div>

        <motion.div
          className="about-foundations__achievement"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="about-foundations__achievement-title">{achievementTitle}</h3>
          <ul className="about-foundations__achievement-list">
            <li>{achievement1}</li>
            <li>{achievement2}</li>
            <li>{achievement3}</li>
            <li>{achievement4}</li>
          </ul>
          <p className="about-foundations__footer">{footer}</p>
          <div className="flex items-center justify-center">
            <TrophyIcon className="w-6 h-6 mr-2" />
            <p className="about-foundations__social-proof">{socialProof}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
